// @ts-ignore
/* eslint-disable */
///////////////////////////////////////////////////////////////////////
//                                                                   //
// this file is autogenerated by service-generate                    //
// do not edit this file manually                                    //
//                                                                   //
///////////////////////////////////////////////////////////////////////
/// <reference path = "api-auto.d.ts" />
import request from '@/utils/ajax'

/**
 * Get scene list
 */
export async function SceneControllerGetScene(
  params: Paths.SceneControllerGetScene.BodyParameters,
): Promise<{
  error: string
  data: Paths.SceneControllerGetScene.Responses
}> {
  // /v1/scene
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/scene`, {
    params: _params,
  })
}

/**
 * Get scene schema by appid
 */
export async function SceneControllerGetSceneSchema(
  params: Paths.SceneControllerGetSceneSchema.BodyParameters,
): Promise<{
  error: string
  data: Paths.SceneControllerGetSceneSchema.Responses
}> {
  // /v1/scene/{appid}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/scene/${_params.appid}`, {
    params: _params,
  })
}
